import { Box, Group } from '@mantine/core';
import { isNullish } from 'remeda';

type SplitProps = React.ComponentProps<typeof Group> &
  React.PropsWithChildren<{
    left?: number;
  }>;

export const Split = ({ left = 50, children, ...groupProps }: SplitProps) => {
  if (left < 0 || left > 100) return null;
  if (isNullish(children) || !Array.isArray(children)) return null;
  if (children.length !== 2) return null;

  const right = 100 - left;

  return (
    <Group align="stretch" wrap="nowrap" {...groupProps}>
      <Box style={{ flexBasis: `calc(${left}% - var(--mantine-spacing-md) / 2)` }}>
        {children[0]}
      </Box>
      <Box style={{ flexBasis: `calc(${right}% - var(--mantine-spacing-md) / 2)` }}>
        {children[1]}
      </Box>
    </Group>
  );
};
